import React, { memo } from 'react';
import ElementsGallery from './ElementsGallery';
import { Page } from 'components/Page';
import { Row, Column, Link } from '@carbon/react';
import Panels from 'components/Panels';
import WorkerStatusPanel from 'components/Panels/WorkerStatusPanel';
import {
  Panel,
  PanelFooter,
  PanelHeader,
  PanelLabel,
} from 'components/Panel';

import './_overrides.scss';
import './_elements-page.scss';

import { useNavigate } from 'react-router-dom';
import useUser from '@/lib/hooks/useUser';

export const ElementsModalIndex = ({ onSelectItem = (elements) => {} }) => {
  const listItemsSize = 'normal';

  return <ElementsGallery
    isModal
    size={listItemsSize || 'normal'}
    onSelectItem={onSelectItem}
  />
}


const ElementsPage = ({ onSelectItem = (elements) => {} }) => {
  const listItemsSize = 'normal';
  const { isAdmin } = useUser();
  return (
    <Page
      pageClass="elements-page"
      mainContentClass={"elements-page__r2"}
      pageTitle="Elemente">
      {/* Admin-only live view of running worker jobs. The component
          renders its own Row/Column wrapper when there is something to
          show and null otherwise, so the page doesn't leak an empty grid
          row of padding in the common idle case. */}
      {isAdmin && <WorkerStatusPanel />}
      <Row >
        <Column md={8} lg={8} sm={4}>
          <Panel halfSize>
            <PanelHeader header>Beschreibung</PanelHeader>
            <PanelLabel>
              Hier findest du alle Bilder und Videos, die du auf deinen Bildschirmen einsetzen kannst.
              Lade eigene Dateien hoch und füge sie per Klick in deine Streams ein.
              Mit dem Filter auf der linken Seite kannst du gezielt nach Format, Kategorie oder Typ suchen — praktisch, wenn die Sammlung größer wird.
            </PanelLabel>
            <Link href="#" onClick={() => history('/help')}>
              Hilfe zu Elementen
            </Link>
            <PanelFooter>

            </PanelFooter>
          </Panel>
        </Column>

        <Column md={4} lg={6} sm={4}>
          <Panels.ElementsUsage small />
        </Column>
        { /*<Panels.ElementsStats />*/ }
      </Row>
      <Row>
        <Column lg={16}><ElementsGallery
          size={listItemsSize || 'normal'}
          onSelectItem={onSelectItem}
        /></Column>
      </Row>
    </Page>
  );
};

export default ElementsPage;
